import { AutoFocusTarget } from '@angular/cdk/dialog';
import { Directive, inject, input, InputSignal, TemplateRef } from '@angular/core';
import { SideSheetSide } from '@libs/common/models';
import { SideSheetService } from './side-sheet.service';

@Directive({
  selector: 'ng-template[uiSideSheetSide]',
  exportAs: 'SideSheetDirective',
})
export class SideSheetDirective {
  private readonly templateRef: TemplateRef<unknown> = inject(TemplateRef);
  private readonly sideSheetService: SideSheetService = inject(SideSheetService);

  public readonly side: InputSignal<SideSheetSide> = input.required({ alias: 'uiSideSheetSide' });
  public readonly width: InputSignal<string | undefined> = input();
  public readonly autoFocusTarget: InputSignal<AutoFocusTarget | undefined> = input();

  public open(): void {
    this.sideSheetService.createSideSheetWithTemplate(
      this.side(),
      this.templateRef,
      undefined,
      this.width(),
      this.autoFocusTarget(),
    );
  }

  public close(): void {
    this.sideSheetService.closeSideSheet(this.side());
  }
}
